import { render, staticRenderFns } from "./UploadImageAndPreview.vue?vue&type=template&id=384d9395"
import script from "./UploadImageAndPreview.vue?vue&type=script&lang=js"
export * from "./UploadImageAndPreview.vue?vue&type=script&lang=js"
import style0 from "./UploadImageAndPreview.vue?vue&type=style&index=0&id=384d9395&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports